import "./index.css";

import { createRoot } from "react-dom/client";

import { App } from "./App";
import { initI18n } from "./i18n";
import type { QmsConfig } from "./interfaces";
import { configUrl } from "./routes/apiRoutes";
import { appStore } from "./store/store";
import { initChatwoot } from "./utils/chatwootService";
import { initGoogleAnalytics, initYandexMetrica } from "./utils/metrics";
import { initSentry } from "./utils/sentry";

let language;
try {
  const resp = await fetch(configUrl);
  const config = (await resp.json()) as QmsConfig;
  appStore.setConfig(config);
  language = config.language;
} catch {
  //
}
await initI18n(language);

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container not found");
}

initSentry();
initYandexMetrica();
initGoogleAnalytics();

const root = createRoot(container);
root.render(<App />);

const locale = appStore.config.language;
initChatwoot(locale);
